import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ElectronService } from '../../services/electron.service';
import { ApisService } from '../../services/apis.service';

import { ToStonesPipe } from '../../pipes/to-stones.pipe';
import { ToLbsPipe } from '../../pipes/to-lbs.pipe';

@Component({
  selector: 'app-jockey-weight-out',
  templateUrl: './jockey-weight-out.component.html',
  styleUrls: ['./jockey-weight-out.component.scss']
})

export class JockeyWeightOutComponent implements OnInit {

  @ViewChild('weightOutStones') weightOutStonesElement: ElementRef;
  @ViewChild('weightOutLbs') weightOutLbsElement: ElementRef;
  @Input() jockey;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  manualEditing = false;
  disableReadScale = false;
  electronMode: boolean = this.electron.isElectron();
  userId: number;
  jockeyWeights: {
    weightOutStones: number,
    weightOutLbs: number,
    overweight: number,
    raw: string
  };
  covidModLbs: number;

  constructor(
    public activeModal: NgbActiveModal,
    private electron: ElectronService,
    private apiService: ApisService,
    private notification: ToastrService,
    private toLbs: ToLbsPipe,
    private toStones: ToStonesPipe
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: false
    };
    this.jockeyWeights = {
      weightOutStones: null,
      weightOutLbs: null,
      overweight: 0,
      raw: ''
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });

    if (!this.electronMode) {
      this.enableManualEdit();
    }
  }

  enableManualEdit(): void {
    this.manualEditing = !this.manualEditing;
    if (this.manualEditing) {
      this.meta.enableSave = false;
      this.disableReadScale = true;
      this.weightOutStonesElement.nativeElement.focus();
    } else {
      this.disableReadScale = false;
      // this.checkRuleBreach();
      this.checkWeight();
    }
  }

  // Modded for COVID
  fillExpectedWeight() {
    if (!this.jockeyWeights.weightOutStones && !this.jockeyWeights.weightOutLbs && this.manualEditing) {
      this.jockeyWeights.raw = 'manual';
      this.jockeyWeights.weightOutStones = Math.floor(
        (this.jockey.weightCarriedValue + this.jockey.penaltyWeight - this.jockey.jockeyClaim) / 14
      );
      this.jockeyWeights.weightOutLbs =
      (this.jockey.weightCarriedValue + this.jockey.penaltyWeight - this.jockey.jockeyClaim) % 14;
    }
  }

  valueChanged(value, attribute) {
    if (this.manualEditing) {
      if (this.jockeyWeights[attribute] !== Number(value)) {
        this.jockeyWeights.raw = 'manual';
      }
    }
  }

  checkWeight(): void {
    this.meta.enableSave =
    (this.jockeyWeights.weightOutStones !== null || this.jockeyWeights.weightOutLbs !== null)
    && !this.checkRuleBreach();
  }

  // Modded for COVID
  checkRuleBreach() {
    let ruleBreachStatus = false;
    const higestDiff = 4;
    const highDiff = 1;
    const lowestDiff = 0;
    const expectedWeight = this.jockey.weightCarriedValue + this.jockey.penaltyWeight - this.jockey.jockeyClaim;
    const rawWeightOut = Number(this.jockeyWeights.weightOutStones) * 14 + Number(this.jockeyWeights.weightOutLbs);
    const roundedWeightOut = this.weightRoundDown(rawWeightOut);
    const rawDifference = rawWeightOut - expectedWeight;
    const roundedDifference = roundedWeightOut - expectedWeight;
    console.log('EXPECTED:', expectedWeight);
    console.log('OUT (raw-round):', rawWeightOut, roundedWeightOut);
    console.log('DIFFERENCE (raw-round):', rawDifference, roundedDifference);
    if ( roundedDifference >= higestDiff) {
      ruleBreachStatus = true;
      this.notification.error(`The Jockey will be ` +
        `${roundedDifference.toFixed(1)} lbs over the weight to be carried.`,
        'Weigh-Out'
      );
    } else if (roundedDifference >= highDiff) {
      this.notification.info(`The Jockey will be ${roundedDifference} lbs ` +
      `over the weight to be carried.`, 'Weigh-Out', { timeOut: 6000 });
    }
    if (rawDifference < lowestDiff) {
      ruleBreachStatus = true;
      this.notification.error(`The Jockey will be ` +
        `${rawDifference.toFixed(1)} lbs below the weight to be carried.`,
        'Weigh-Out'
      );
    }
    if (ruleBreachStatus) {
      if (this.jockeyWeights.raw === 'manual') {
        this.enableManualEdit();
      }
    }
    this.jockeyWeights.overweight = roundedDifference;
    return ruleBreachStatus;
  }

  weightRoundDown(weightLbs) {
    if (Math.abs(weightLbs) % 1 > 0.5) {
      return Math.round(Math.abs(weightLbs)) * Math.sign(weightLbs);
    } else {
      return Math.floor(Math.abs(weightLbs)) * Math.sign(weightLbs);
    }
  }

  readScale(): void {
    this.manualEditing = false;
    this.disableReadScale = true;

    this.electron.errorSerialPort().catch(err => {
      this.electron.closeSerialPort();
    });

    this.electron.getSerialPorts()
    .then((ports: [any]) => {
      console.log(ports);
      if (ports.length) {
        const portConfig =  { baudRate: 9600, dataBits: 8, stopBits: 1, parity: 'none', rtscts: true };
        const portName = ports[String(ports.length - 1)];

        console.log(portConfig);
        console.log(portName);

        this.electron.readSerialPort(portName, portConfig)
        .then((data: string) => {
          console.log(`[ DEBUG ] DATA FROM ${portName}:`, data.substring(1, data.length-1));
          this.electron.closeSerialPort();
          this.disableReadScale = false;
          console.log(data, data.substring(1, data.length - 1), data.substring(1, data.length - 1).split(' '));
          this.jockeyWeights = {
            weightOutStones: Number(data.substring(1, data.length - 1).trim().replace('  ', ' ').split(' ')[0]),
            weightOutLbs: Number(data.substring(1, data.length - 1).trim().replace('  ', ' ').split(' ')[1]),
            overweight: 0,
            raw: data
          };
          this.checkWeight();
          // this.checkRuleBreach();
        })
        .catch(err => {
          console.error(`[ DEBUG ] Error Reading from ${portName}:`, err);
          this.notification.info(`Error reading from ${portName}. Maybe the scale was not settled. Try again.`, 'Scale Reading');
          this.electron.closeSerialPort();
          this.jockeyWeights.weightOutStones = null;
          this.jockeyWeights.weightOutLbs = null;
          this.checkWeight();
          this.disableReadScale = false;
        });

      } else {
        console.error('[ DEBUG ]  No Serial Ports Detected');
        this.notification.error(`No serial port detected.`, 'Scale Reading');
        this.jockeyWeights.weightOutStones = null;
        this.jockeyWeights.weightOutLbs = null;
        this.checkWeight();
        this.disableReadScale = false;
      }
    })
    .catch(err => {
      console.error('[ DEBUG ] Cannot get the list of serial ports', err);
      this.notification.error(`Could't access serial ports list.`, 'Scale Reading');
    });
  }

  confirm(): void {
    this.meta.saving = true;
    const weightDisplayedLbs = (Number(this.jockeyWeights.weightOutStones) * 14) + Number(this.jockeyWeights.weightOutLbs);
    const payload = {
      animalId: this.jockey.animalId,
      jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      weightDisplayed: weightDisplayedLbs,
      weightRecorded: this.weightRoundDown(weightDisplayedLbs),
      jockeyOverweight: this.jockeyWeights.overweight,
      raw: this.jockeyWeights.raw,
      weighed: 'O',
      type: this.jockeyWeights.raw === 'manual' ? 'M' : 'S',
      updatedBy: this.userId
    };
    console.log(`[ DEBUG ] Sending payload`, payload);
    this.apiService.updateJockeyWeights(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        res => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.activeModal.close(res);
          this.notification.success(`${this.jockey.jockeyName} weight-out has been saved.`, 'Weigh-Out');
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the weight-out. Check your connection and Try again.`, 'Weigh-Out');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    if (this.electronMode) {
      this.electron.closeSerialPort();
    }
    this.activeModal.dismiss(action);
  }
}
